import {
  type ComponentRegistry,
  type PresenceComponentEntry,
} from './contracts/component-registry';
import { PresenceState } from './presence-state';
import { type FieldEntryGrouping } from './types';
import { getKey } from './utils';

export class PresenceComponentRegistry
  implements ComponentRegistry<PresenceComponentEntry>
{
  #componentRegistry = new Map<string, PresenceComponentEntry[]>();

  getComponent(grouping: FieldEntryGrouping): PresenceComponentEntry[] | undefined {
    const key = getKey(grouping);

    return this.#componentRegistry.get(key);
  }

  registerComponent(
    grouping: FieldEntryGrouping,
    registry: PresenceComponentEntry
  ): void {
    const key = getKey(grouping);

    if (!this.#componentRegistry.has(key)) {
      this.#componentRegistry.set(key, []);
    }

    const components = this.#componentRegistry.get(key);

    if (!components) {
      return;
    }

    this.#deleteComponent(components, registry.componentId);

    components.push(registry);
  }

  unregisterComponent(grouping: FieldEntryGrouping, componentId: string): void {
    const key = getKey(grouping);
    const components = this.#componentRegistry.get(key);

    if (components) {
      this.#deleteComponent(components, componentId);

      if (components.length === 0) {
        this.#componentRegistry.delete(key);
      }
    }
  }

  #deleteComponent(components: PresenceComponentEntry[], componentId: string): boolean {
    const index = components.findIndex((c) => c.componentId === componentId);

    if (index > -1) {
      components.splice(index, 1);

      return true;
    }

    return false;
  }
}

export const presenceComponentRegistry = new PresenceComponentRegistry();
export const presenceState = new PresenceState(presenceComponentRegistry);
